export const parseTrakaWidth = (value: unknown): number | null => {
    const text = String(value ?? '').trim()
    if (!/^\d+(?:[.,]\d+)?\s*(?:mm)?$/i.test(text)) return null
    const width = Number(text.replace(/\s*mm$/i, '').replace(',', '.'))
    return Number.isFinite(width) && width > 0 ? width : null
}

export const matchesTrakaWidth = (title: unknown, width: unknown): boolean => {
    const expected = parseTrakaWidth(width)
    if (expected === null) return false
    // Compare complete measurements, so 500 cannot match 1500 or 0,500 mm.
    const measurements = /(^|[^\d.,])(\d+(?:[.,]\d+)?)\s*mm\b/gi
    let match: RegExpExecArray | null
    while ((match = measurements.exec(String(title ?? ''))) !== null) {
        if (Number(match[2].replace(',', '.')) === expected) return true
    }
    return false
}
